import DailyQuotaProgressWidget from "../widgets/livewire/DailyQuotaProgressWidget";
import SentToQaProgressWidget from "../widgets/livewire/SentToQaProgressWidget";
import AppsClosedTodayWidget from "../widgets/livewire/AppsClosedTodayWidget";
import { useLiveWireStore } from "@/stores/livewire";
import { useShallow } from "zustand/react/shallow";
import AppsReceivedTodayWidget from "../widgets/livewire/AppsReceivedTodayWidget";
import ApplicantCommsWidget from "../widgets/livewire/ApplicantCommsWidget";
import CommunityCommsWidget from "../widgets/livewire/CommunityCommsWidget";
import KickbacksTodayWidget from "../widgets/livewire/KickbacksTodayWidget";
import AccuracyTodayWidget from "../widgets/livewire/AccuracyTodayWidget";

const DailyAnalystOverView = () => {
  return (
    <div className="analyst-overview dashboard">
      <div className="inner d-flex gap-2 flex-column">
        <div className="d-flex flex-row gap-2" >
          <DailyQuotaProgressWidget size="md" />
          <AppsClosedTodayWidget />
          <AppsReceivedTodayWidget />
          <KickbacksTodayWidget />
          <AccuracyTodayWidget />
          {/* <ApplicantCommsWidget /> */}
          {/* <CommunityCommsWidget /> */}
        </div>
        <div className="d-flex flex-row flex-fill gap-2">
          <SentToQaProgressWidget />
        </div>
      </div>
    </div>
  );
};

export default DailyAnalystOverView;
